import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { AppProvider } from './context';
import AuthProvider from 'react-auth-kit/AuthProvider';
import createStore from 'react-auth-kit/createStore';
// import 'bootstrap/dist/css/bootstrap.min.css';

const store = createStore({
  authName: 'token',
  authType: 'cookie',
  cookieDomain: window.location.hostname,
  cookieSecure: false,
});
ReactDOM.render(
  <React.StrictMode>
    <AuthProvider store={store}>
      <AppProvider>
        <App />
      </AppProvider>
    </AuthProvider>
  </React.StrictMode>,
  document.getElementById('root')
);


